import React, { Component } from 'react';
import settings from './../../config.js';
import isMobileDevice from './../common/mobile-device-helper';
import { Translate } from './../common/translator';

function buildRec(node, nodes) {
  if (nodes.has(node.idPlant)) {
    node.items = nodes.get(node.idPlant);
    node.items.forEach(n=> buildRec(n, nodes));
  }
}

function getNodeInfo(idObject) {
  return new Promise((resolve, reject)=> {
    resolve([]);
  });
}

const dataSourceScheme = {
  model: {
    id: 'idPlant',
    hasChildren: item => item.numChildren && item.numChildren > 0
  }
};

export default class TreeView extends Component {
  constructor() {
    super();
    this.attachedTreeEvents = new Map();
    this.nodeCache = new Map();
    //this._fillCache(this.nodeCache);
    this.expandToNodes = null;
    this.state = {
      currentIdPlant: 0
    };
    this.remoteDataSource = new kendo.data.HierarchicalDataSource({
      transport: {
        read: this._fetchNode.bind(this)
      },
      schema: dataSourceScheme
    });
  }

  _fillCache(data, cache) {
    for (let i = 0; i < data.nodes.length; i++) {
      let node = data.nodes[i];
      // Build childs
      if (!cache.has(node.parentIdPlant)) {
        cache.set(node.parentIdPlant, [node]);
      } else {
        let childs = cache.get(node.parentIdPlant);

        if(childs.findIndex(n=>n.name === node.name)  > -1){
          console.log('Double node..');
        }else{
          childs.push(node);
        }
      }

      // Ensure that we dont have nodes not in the cache
      if (!cache.has(node.idPlant)) {
        cache.set(node.idPlant, []);
      }
    }

    cache.forEach(child => {
      const parent = cache.get(child.parentIdPlant);
      if (parent) {
        child.parentModelCode = parent.modelCode;
        child.parentModelId = parent.modelId;
      }
    });

    cache.forEach(childs => childs.sort((a,b)=> a.name.localeCompare(b.name)));

  }

  _findNode(idPlant) {
    return this.props.treeData.find(elem => elem.idPlant === idPlant ? true: false);
  }

  _findNodePath(idPlant, cache) {
    let path = [];
    let currentNode = this._findNode(idPlant);
    //let currentNode = cache.get(idPlant);
    if (!currentNode) {
      throw Error('_findNodePath: can not find node in cache : ' + idPlant);
    }

    while (currentNode.parentIdPlant != 0) {
      path.push(currentNode.idPlant);
      currentNode = this._findNode(currentNode.parentIdPlant);
    }

    path.push(currentNode.idPlant);

    return path.reverse();
  }

  _attachTreeEvents() {
    // Add events as key/val
    this.attachedTreeEvents.set('mousedown', this._treeRightClicked.bind(this));

    //Loop through and add events
    this.attachedTreeEvents.forEach((val, key)=> {
      $(this.refs.treeViewContainer).on(key, val);
    });
  }

   _detachTreeEvents() {
    this.attachedTreeEvents.forEach((val, key)=> {
      $(this.refs.treeViewContainer).off(key, val);
    });
  }

  _treeRightClicked(event) {
    this.props.contextClosed();
    if ((event.ctrlKey && event.which === 1) || (event.which === 3)) {
      var node = this.treeView.dataItem(event.target);
      this._selectionChanged(node);
      this.props.contextOpened(node, event);
    }
  }

  _selectionChangedEvent(e) {
    let currentNode = this.treeView.dataItem(e.node);
    this._selectionChanged(currentNode);
  }

  _selectionChanged(currentNode) {
    this.setState({ currentIdPlant: currentNode.idPlant });
    this.props.selectionChanged(currentNode.idPlant, currentNode.idObject, currentNode.modelCode);
  }

  collapseNode(node) {
    let nodeToExpand = this.treeView.dataSource.get(node.idPlant);
    let nodeItem = this.treeView.findByUid(nodeToExpand.uid);
    this.treeView.collapse(nodeItem);
    if (node.children && (typeof node.children.data === 'function')) {
      node.children.data().forEach((child) => {
        this.collapseNode(child);
      });
    }
  }

  expandNode(node) {
    this._expandNodes(node);
  }

  _addLoadingIcon(node) {
    if (this.treeView && node.idPlant) {
      let dataNode = this.treeView.dataSource.get(node.idPlant);
      let treeNode = this.treeView.findByUid(dataNode.uid);
      let loadingTarget = $('span.k-icon.k-plus', treeNode);
      if (loadingTarget) {
        loadingTarget.removeClass('k-plus');
        loadingTarget.addClass('k-icon k-loading');
      }
    }
  }

  _removeLoadingIcon(node) {
    if (this.treeView && node.idPlant) {
      let dataNode = this.treeView.dataSource.get(node.idPlant);
      let treeNode = this.treeView.findByUid(dataNode.uid);
      let loadingTarget = $('span.k-icon.k-loading', treeNode);
      if (loadingTarget) {
        loadingTarget.removeClass('k-loading');
        loadingTarget.addClass('k-icon k-plus');
      }
    }
  }

  _expandNodes(node) {
    let dataNode = this.treeView.dataSource.get(node.idPlant);
    let treeNode = this.treeView.findByUid(dataNode.uid);
    this.treeView.expand(treeNode);
    if (dataNode.items && dataNode.items.length > 0) {
      dataNode.items.forEach((childNode) => {
        this._expandNodes(childNode);
      });
    }
  }

  _loadTreeNode(idPlant) {
    this.props.isLoadingChanged(true);
    this.setState({ currentIdPlant: idPlant });
    this.treeView.collapse('.k-item');

    if (idPlant === 0) {
      this.props.isLoadingChanged(false);
      return;
    }

    let path = this._findNodePath(idPlant, this.nodeCache);
    path.forEach(idPlant => {
      let dataNode = this.treeView.dataSource.get(idPlant);
      if (!dataNode) {
        console.log(idPlant, dataNode, path, this.treeView.dataSource);
      }

      let treeNode = this.treeView.findByUid(dataNode.uid);
      //console.log(treeNode);
      this.treeView.expand(treeNode);
    });
    this._selectNode(path[path.length - 1]);

  }

  _selectNode(idPlant) {
    let node = this.treeView.dataSource.get(idPlant);
    let nodeItem = this.treeView.findByUid(node.uid);

    this.treeView.one('change', () => {
      var itemScrollTop = this.treeView.select()[0].offsetTop;
      $(this.refs.treeViewContainer).animate({ scrollTop: itemScrollTop });
    });

    this.treeView.select(nodeItem);
    if (nodeItem && (nodeItem.length > 0)) {
      nodeItem[0].scrollIntoView();
    }

    this.treeView.unbind('expand');
    this.props.isLoadingChanged(false);
  }

  _fetchNode(options) {
    if (this.treeView) {
      var item = $(this.treeView.current());
      item.context.className = item.context.className.replace('k-plus', '');
    }

    var node = {};

    if (options.data && options.data.idPlant) {
      node = this.treeView.dataSource.get(options.data.idPlant);
    } else {
      node.idPlant = 0;
    }

    if (this.nodeCache.has(node.idPlant)) {
      let childs = this.nodeCache.get(node.idPlant);
      options.success(childs);
    } else {
      $.getJSON( "json.json", data => {
        this._fillCache(data, this.nodeCache);
        options.success(this.nodeCache.get(node.idPlant));
        this.props.setData(data);
      });
    }
  }

  _dragEnd(e) {
    let nodeToDrag = this.treeView.dataItem(e.sourceNode);
    let newParent = this.treeView.dataItem(e.destinationNode);
    this.props.nodeDragEnd(nodeToDrag, newParent.idPlant);
  }

  _drop(e) {
    if (!window.confirm(Translate('confirmMove'))) {
      e.setValid(false);
    }

  }

  _onDatabound(e) {
    if (this.expandToNodes) {
      let currentNode = this.treeView.dataItem(e.node);
      if (this.expandToNodes.has(currentNode.idPlant)) {
        if (currentNode.numChildren > 0) {
          currentNode.children._data.forEach((child) => {
            this._expandNode(child);
          });
        }
      } else {
        this.expandToNodes.clear();
        this.expandToNodes = null;
      }
    }
  }

  _onExpand(e) {
    if (this.expandToNodes) {
      let currentNode = this.treeView.dataItem(e.node);
      if (this.expandToNodes.has(currentNode.idPlant)) {
        if (currentNode.numChildren > 0) {
          currentNode.children._data.forEach((child) => {
            this._expandNode(child);
          });
        }
      } else {
        this.expandToNodes.clear();
        this.expandToNodes = null;
      }
    }
  }

  componentDidMount() {

    var fhoTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-folder-o"></i> #= item.name #</div>';
    var dhhTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-files-o"></i> #= item.name #</div>';
    var fgoTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-folder"></i> #= item.name #</div>';
    var fhhTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-folder"></i> #= item.name #</div>';
    var ihoTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-wrench"></i> #= item.name #</div>';
    var dhoTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-file-text-o"></i> #= item.name #</div>';
    var waoTemplate = '<div className="nodeIconTemplate" title="#= item.modelCode #"><i class="fa fa-camera"></i> #= item.name #</div>';

    this.treeView =  $(this.refs.treeViewContainer).kendoTreeView({
      template:
      '#if (item.modelCode == "FHO") {# ' + fhoTemplate + ' #} ' +
      'else if (item.modelCode == "DHH") {# ' + dhhTemplate + ' #} ' +
      'else if (item.modelCode == "FGO") {# ' + fgoTemplate + ' #} ' +
      'else if (item.modelCode == "FHH") {# ' + fhhTemplate + ' #} ' +
      'else if (item.modelCode == "IHO") {# ' + ihoTemplate + ' #} ' +
      'else if (item.modelCode == "DHO") {# ' + dhoTemplate + ' #} ' +
      'else if (item.modelCode == "WAO") {# ' + waoTemplate + ' #} ' +
      'else {# #= item.name # #}#',
      dataSource: this.remoteDataSource,
      loadOnDemand: true,
      messages:{
        retry: Translate('retry'),
        requestFailed: Translate('requestFailed'),
        loading: Translate('loading')
      },
      dataTextField: 'name',
      select: this._selectionChangedEvent.bind(this),
      dragend: this._dragEnd.bind(this),
      drop: this._drop.bind(this),
      navigate: (e) => {
        let treeViewContainer = $('div.treeView');
        let treeNode = $(e.node);
        const treeNodeHeight = 19;
        if ((treeNode.offset().top - treeViewContainer.offset().top + treeNodeHeight) >= (treeViewContainer.height() - treeNodeHeight)) {
          treeViewContainer.scrollTop(treeViewContainer.scrollTop() + treeNodeHeight);
        } else if ((treeNode.offset().top - treeViewContainer.offset().top) <= 0) {
          treeViewContainer.scrollTop(treeViewContainer.scrollTop() - treeNodeHeight);
        }
      },
      autoScroll: true,
      animation: false,
    }).data('kendoTreeView');

    this._attachTreeEvents();

    // Opening via url param etc.
    if (this.props.idPlant !== null) {
      this._loadTreeNode(this.props.idPlant);
    }
  }

  _updateNode(node) {
    const nodeWithChange = this.treeView.dataSource.get(node.idPlant);

    // TODO update icon in a future where icon comes from server
    nodeWithChange.set('modelId', node.modelId);
    nodeWithChange.set('modelCode', node.modelCode);

    //nodeWithChange.set('icon', node.icon);
    nodeWithChange.set('name', node.name);
  }

  _refreshNode(idPlant, refreshChilds) {
    const nodeWithChange = this.treeView.dataSource.get(idPlant);
    getNodeInfo(nodeWithChange.idObject).then(info=> {
      if (info.length > 0) {
        const updateNodeInfo = info[0];
        nodeWithChange.set('name', updateNodeInfo.name);

        if (refreshChilds) {
          this.nodeCache.delete(nodeWithChange.idPlant);
          nodeWithChange.set('numChildren', updateNodeInfo.numChildren);

          //Treeview will not refresh when hasChildren is false, set to true before calling load() to refresh tree.
          nodeWithChange.set('hasChildren', true);
          nodeWithChange.loaded(false);
          nodeWithChange.load();
          if (updateNodeInfo.numChildren === 0) {
            //Set correct hasChildren state AFTER refreshing tree
            nodeWithChange.set('hasChildren', false);
          }
        }
      }
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Update IF idplant in props has changed AND if internal state has not changed. This is to prevent acting on self changes
    if (this.state && nextProps.idPlant !== null && nextProps.idPlant !== this.state.currentIdPlant && nextState.currentIdPlant === this.state.currentIdPlant) {
      this._loadTreeNode(nextProps.idPlant);
      return false;
    }

    return false;
  }

  render() {
    return <div style={{ overflow: 'visible' }} ref='treeViewContainer'/>;
  }

  componentWillUnmount() {
    this._detachTreeEvents();
  }
}



/** WEBPACK FOOTER **
 ** app/components/tree-view/tree-view.js
 **/